import axios from 'axios'
import { createSid, createParams } from "@/utils/javaParams"
import md5 from 'js-md5'
import { devhost } from "./request"

const uri = "https://japi.233.com"

const service = axios.create({
    baseURL: uri
})

service.interceptors.request.use(function (config) {
    const { method, data, url } = config
    const { params } = createParams(method, data, url)
    const sid = createSid()
    config.url = createParams(method, data, url).url
    config.headers['sid'] = sid
    let sign = ''
    if (Object.prototype.toString.call(data) == '[object FormData]') sign = md5("RZRRNN9RXYCP" + sid).toUpperCase()
    else if (method == 'get') sign = md5("RZRRNN9RXYCP" + sid + decodeURIComponent(params)).toUpperCase()
    else sign = md5("RZRRNN9RXYCP" + sid + params).toUpperCase()
    config.headers['sign'] = sign
    if (localStorage.getItem('javatoken')) {
        config.headers['token'] = localStorage.getItem('javatoken')
    }
    config.headers['unioncode'] = process.env.NODE_ENV === 'development' ? devhost : window.location.host

    return config
})

service.interceptors.response.use((res) => {
    const { data, config } = res
    const isSuccess = config.headers.isSuccess === true
    console.log(isSuccess);
    // 是否直接返回成功
    if (isSuccess) {
        return data
    }
    if (data.status) {
        return data
    } else {
        return Promise.reject(data)
    }
}, (err) => {
    console.log(err);
    return Promise.reject(err)
})


export default service